import API from '@/api';
const Request = API.get('Request');
// const Cases = API.get('Cases');

export default ({
  namespaced: true,
  state: {
    isGenerated: false,
    plan: false,
    file_careplan: null,
    
    prescription: false,
    file_prescription: null,

    certificate: false,
    file_medical_certificate: null,

    laboratory: false,
    file_laboratory: null,

    destination_email: '',

    medex: false,
    certificate_rejected: false,
    tests: [],
    image: false,
    rest_days: '',
    other_tests: "",
    certificate_remark: '',
    rejection_reason: '',
    tests_index: null,
    // consultation_request_id: null
  },

  /* ---------------------------------------------------------------- FUNCTION SEPARATOR ---------------------------------------------------------------- */

  getters: {
    isGenerated: state => state.isGenerated,
    plan: state => state.plan,
    file_careplan: state => state.file_careplan,
    
    prescription: state => state.prescription,
    file_prescription: state => state.file_prescription,

    certificate: state => state.certificate,
    file_medical_certificate: state => state.file_medical_certificate,

    laboratory: state => state.laboratory,
    file_laboratory: state => state.file_laboratory,

    destination_email: state => state.destination_email,

    medex: state => state.medex, // sub
    certificate_rejected: state => state.certificate_rejected, // sub
    tests: state => state.tests,
    image: state => state.image,
    rest_days: state => state.rest_days,
    isOthers: state => state.isOthers,
    certificate_remark: state => state.certificate_remark,
    rejection_reason: state => state.rejection_reason,
    tests_index: state => state.tests_index,
    other_tests: state => state.other_tests
  },

  /* ---------------------------------------------------------------- FUNCTION SEPARATOR ---------------------------------------------------------------- */

  mutations: {
    setTestsIndex(state, index) {
      state.tests_index = index
    },

    setIsGenerated(state, value) {
      state.isGenerated = value
    },

    /* ################################################## METHOD SEPARATORS ################################################## */

    setPlan(state) {
      state.plan = !state.plan
    },

    setPlanValue(state, value) {
      state.plan = value
    },

    setFilePlan(state, value) {
      state.file_careplan = value
    },

    /* ################################################## METHOD SEPARATORS ################################################## */

    setPrescription(state) {
      state.prescription = !state.prescription
    },

    setPrescriptionValue(state, value) {
      state.prescription = value
    },

    setFilePrescription(state, value) {
      state.file_prescription = value
    },

    /* ################################################## METHOD SEPARATORS ################################################## */

    setMedex(state, value) {
      state.medex = value
    },

    /* ################################################## METHOD SEPARATORS ################################################## */

    setCertificate(state, value) {
      state.certificate = value
    },

    setFileMedicalCertificate(state, value) {
      state.file_medical_certificate = value
    },

    /* ################################################## METHOD SEPARATORS ################################################## */

    setCertificateRejected(state, value) {
      state.certificate_rejected = value
    },

    /* ################################################## METHOD SEPARATORS ################################################## */

    setLaboratory(state, value) {
      state.laboratory = value
    },

    setFileLaboratory(state, value) {
      state.file_laboratory = value
    },

    /* ################################################## METHOD SEPARATORS ################################################## */

    setDestinationEmail(state, value) {
      console.log("set destination_email");
      console.log(value);
      console.log(state);
      state.destination_email = value
    },



    /* ################################################## METHOD SEPARATORS ################################################## */

    updateTest(state, {name, value}) {
      if (state.tests) {
        var index = state.tests.findIndex(item => item == name)
        if (value) {
          if (index < 0) {
            state.tests.push(name)
          }
        } else {
          if (index >= 0) {
            state.tests.splice(index, 1)
          }
        }
      } else {

        // make sure that state.tests is an array and if not, force it to be array
        if(!this.checkObject(state.tests)) {
          state.tests = [];
          state.tests.push(name);
        }

      }

      console.log('updateTest(store)', name, value, state.tests)
    },

    /* ################################################## METHOD SEPARATORS ################################################## */

    setTests(state, value) {
      state.tests = value
    },

    /* ################################################## METHOD SEPARATORS ################################################## */

    setImage(state) {
      state.image = !state.image
    },

    /* ################################################## METHOD SEPARATORS ################################################## */

    setRestDays(state, value) {
      state.rest_days = value
    },

    /* ################################################## METHOD SEPARATORS ################################################## */

    setTestOthers(state, value) {
      state.other_tests = value
    },

    /* ################################################## METHOD SEPARATORS ################################################## */

    setCertificateRemark(state, value) {
      state.certificate_remark = value
    },

    /* ################################################## METHOD SEPARATORS ################################################## */

    setRejectionReason(state, reason) {
      state.rejection_reason = reason
    },

    /* ################################################## METHOD SEPARATORS ################################################## */

    loadSavedData(state, requests) {
      if (requests) {

        if (requests.length >= 1 && requests != null) {
          var request = requests.slice(-1)[0];

          console.log("request is loaded");
          console.log(request);

          let db_laboratoy_tests = null;
          console.log("laboratory tests", request.laboratory_tests);
          if(request.laboratory_tests) {
            db_laboratoy_tests = JSON.parse(request.laboratory_tests);
          }

          state.plan = request.has_careplan,
          state.file_careplan = request.file_careplan,

          state.prescription = request.has_prescription,
          state.file_prescription = request.file_prescription,

          state.certificate = request.has_medical_certificate,
          state.file_medical_certificate = request.file_medical_certificate,

          state.laboratory = request.has_laboratory,
          state.file_laboratory = request.file_laboratory,

          state.destination_email = request.destination_email,

          state.tests = db_laboratoy_tests,
          
          state.other_tests = request.other_tests,

          state.medex = request.send_to_medexpress,
          state.image = request.image_request,
          state.certificate_remark = request.cert_remark,
          state.rejection_reason = request.cert_rejected_reason,
          state.rest_days = request.rest_days
        }

      } else {

        state.plan = false;
        state.laboratory = false;
        state.certificate = false;
        state.prescription = false;
        state.tests = [];
        state.other_tests = "";

      } 
    },

    /* ################################################## METHOD SEPARATORS ################################################## */

    checkObject(arr) {
      // check if arr is array
      const result = Array.isArray(arr);

      if(result) {
        return true;
      } else {
        return false;
      }
    },
    
    /* ################################################## METHOD SEPARATORS ################################################## */

    clearStoreData(state) {
      state.plan = false;
      state.prescription = false;
      state.file_prescription = false;
      state.laboratory = false;

      state.destination_email = '',

      state.medex = false;
      state.certificate = false;
      state.certificate_rejected = false;
      state.tests = [];
      state.image = false;
      state.rest_days = '';
      state.other_tests = null;
      state.certificate_remark = '';
      state.rejection_reason = '';
      state.isGenerated = false;
      // state.consultation_request_id = null
    },
    // setConsultationRequestId(state, payload) {
    //   state.consultation_request_id = payload;
    //   console.log(state.consultation_request_id, payload, 'setConsultationRequestId')
    // }
  },

  /* ---------------------------------------------------------------- FUNCTION SEPARATOR ---------------------------------------------------------------- */

  actions: {
    async create({getters}, { id, sendPdf, generatePdf, request_data}) {
      console.log({ getters });
      const payload = {
        request_data,
        sendPdf,
        generatePdf,
        send_careplan: getters.plan ? 1 : 0,
        send_prescription: getters.prescription ? 1 : 0,
        send_laboratory: getters.laboratory ? 1 : 0,
        send_medical_certificate: getters.certificate ? 1 : 0,
        case_consultation_id: id,
        has_careplan: getters.plan ? 1 : 0,
        has_prescription: getters.prescription ? 1 : 0,
        has_laboratory: getters.laboratory ? 1 : 0,
        has_medical_certificate: getters.certificate ? 1 : 0,
        image_request: getters.image ? 1 : 0,
        send_to_medexpress: getters.medex ? 1 : 0,
        rest_days: getters.rest_days,
        cert_remark: getters.certificate_remark,
        cert_rejected_reason: getters.rejection_reason,
        laboratory_tests: getters.tests,
        other_tests: getters.other_tests,
        destination_email: getters.destination_email,
        // doctor_id: null
      }

      payload.laboratory_tests = [...new Set(payload.laboratory_tests)];
      console.log({payload}, 'Request create');

      return await Request.create(payload);

      /*await Request.create(payload).then(async response => {
        // commit('setConsultationRequestId', response.data.id);
        if (sendPdf) {
          // let consultationRequestId = response.data.id;
          
          await Cases.sendPdf(consultationRequestId)
          .then(response => {
            console.log({ response }, "cases send pdf response")
          })
          .catch(error => {
            console.log({ error }, "cases error")
          })
        }
      })*/
    },

    /* ################################################## METHOD SEPARATORS ################################################## */

    async generate({getters, state}, { id, sendPdf, generatePdf, request_data, case_info  }) {
      const payload = {
        request_data,
        sendPdf,
        generatePdf,
        case_info,
        case_consultation_id: id,
        
        has_careplan: getters.plan ? 1 : 0,
        has_prescription: getters.prescription ? 1 : 0,
        has_laboratory: getters.laboratory ? 1 : 0,
        has_medical_certificate: getters.certificate ? 1 : 0,
        
        laboratory_tests: getters.tests,
        send_careplan: getters.plan ? 1 : 0,
        send_prescription: getters.prescription ? 1 : 0,
        send_laboratory: getters.laboratory ? 1 : 0,
        send_medical_certificate: getters.certificate ? 1 : 0,
        image_request: getters.image ? 1 : 0,
        send_to_medexpress: getters.medex ? 1 : 0,
        rest_days: getters.rest_days,
        cert_remark: getters.certificate_remark,
        cert_rejected_reason: getters.rejection_reason,
        other_tests: getters.other_tests,
        destination_email: getters.destination_email,
      }
      
      // if (getters.other_tests) {
      //   payload.laboratory_tests.push(getters.other_tests)
      // }

      payload.laboratory_tests = [...new Set(payload.laboratory_tests)];

      let response = await Request.create(payload);
      console.log("[request/generate]", response, payload);

      state.file_careplan = response.data.file_careplan;
      state.file_prescription = response.data.file_prescription;
      state.file_medical_certificate = response.data.file_medical_certificate;
      state.file_laboratory = response.data.file_laboratory;

      return response
    },
  }
})